/**
 * DIVAN MÖBLER - Shopify Theme v2
 * Interactive behaviors: hero slider, mobile menu, cart drawer,
 * search, gallery, tabs, scroll-to-top, cookie consent
 */
document.addEventListener('DOMContentLoaded', function () {

    // ==================== HERO BANNER ====================
    const heroBanner = document.getElementById('heroBanner');
    if (heroBanner) {
        const slides = heroBanner.querySelectorAll('.hero-slide');
        const dots = heroBanner.querySelectorAll('.hero-dot');
        const prevBtn = document.getElementById('heroPrev');
        const nextBtn = document.getElementById('heroNext');
        let current = 0;
        let interval;

        function goToSlide(idx) {
            slides.forEach(s => s.classList.remove('active'));
            dots.forEach(d => d.classList.remove('active'));
            current = (idx + slides.length) % slides.length;
            slides[current].classList.add('active');
            dots[current].classList.add('active');
        }

        function startAuto() {
            interval = setInterval(() => goToSlide(current + 1), 6000);
        }

        function resetAuto() {
            clearInterval(interval);
            startAuto();
        }

        if (prevBtn) prevBtn.addEventListener('click', () => { goToSlide(current - 1); resetAuto(); });
        if (nextBtn) nextBtn.addEventListener('click', () => { goToSlide(current + 1); resetAuto(); });
        dots.forEach(dot => {
            dot.addEventListener('click', () => { goToSlide(parseInt(dot.dataset.dot)); resetAuto(); });
        });

        // Touch support
        let touchStartX = 0;
        heroBanner.addEventListener('touchstart', e => { touchStartX = e.touches[0].clientX; }, { passive: true });
        heroBanner.addEventListener('touchend', e => {
            const diff = touchStartX - e.changedTouches[0].clientX;
            if (Math.abs(diff) > 50) {
                diff > 0 ? goToSlide(current + 1) : goToSlide(current - 1);
                resetAuto();
            }
        }, { passive: true });

        if (slides.length > 1) startAuto();
    }

    // ==================== MOBILE MENU ====================
    const mobileToggle = document.getElementById('mobileMenuToggle');
    const mobileMenu = document.getElementById('mobileMenu');
    const mobileOverlay = document.getElementById('mobileOverlay');
    const mobileClose = document.getElementById('mobileMenuClose');

    function openMobile() {
        mobileMenu.classList.add('open');
        mobileOverlay.classList.add('open');
        document.body.style.overflow = 'hidden';
    }
    function closeMobile() {
        mobileMenu.classList.remove('open');
        mobileOverlay.classList.remove('open');
        document.body.style.overflow = '';
    }

    if (mobileToggle) mobileToggle.addEventListener('click', openMobile);
    if (mobileClose) mobileClose.addEventListener('click', closeMobile);
    if (mobileOverlay) mobileOverlay.addEventListener('click', closeMobile);

    // Mobile subcategory toggles
    document.querySelectorAll('[data-toggle-sub]').forEach(btn => {
        btn.addEventListener('click', () => {
            const subcats = btn.nextElementSibling;
            const isExpanded = subcats.classList.contains('expanded');
            // Close all
            document.querySelectorAll('.mobile-menu__subcats').forEach(s => s.classList.remove('expanded'));
            document.querySelectorAll('[data-toggle-sub]').forEach(b => b.classList.remove('expanded'));
            if (!isExpanded) {
                subcats.classList.add('expanded');
                btn.classList.add('expanded');
            }
        });
    });

    // ==================== CART DRAWER ====================
    const cartToggle = document.getElementById('cartToggle');
    const cartDrawer = document.getElementById('cartDrawer');
    const cartOverlay = document.getElementById('cartOverlay');
    const cartClose = document.getElementById('cartClose');

    function openCart() {
        cartDrawer.classList.add('open');
        cartOverlay.classList.add('open');
        document.body.style.overflow = 'hidden';
    }
    function closeCart() {
        cartDrawer.classList.remove('open');
        cartOverlay.classList.remove('open');
        document.body.style.overflow = '';
    }

    if (cartToggle) cartToggle.addEventListener('click', openCart);
    if (cartClose) cartClose.addEventListener('click', closeCart);
    if (cartOverlay) cartOverlay.addEventListener('click', closeCart);

    // ==================== SEARCH ====================
    const searchToggle = document.getElementById('searchToggle');
    const searchOverlay = document.getElementById('searchOverlay');

    if (searchToggle) {
        searchToggle.addEventListener('click', () => {
            searchOverlay.classList.add('open');
            document.body.style.overflow = 'hidden';
            setTimeout(() => {
                const input = document.getElementById('searchInput');
                if (input) input.focus();
            }, 100);
        });
    }

    if (searchOverlay) {
        searchOverlay.addEventListener('click', (e) => {
            if (e.target === searchOverlay) {
                searchOverlay.classList.remove('open');
                document.body.style.overflow = '';
            }
        });
    }

    // Close with Escape
    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
            closeMobile();
            closeCart();
            if (searchOverlay) {
                searchOverlay.classList.remove('open');
                document.body.style.overflow = '';
            }
        }
    });

    // ==================== FEATURED SLIDER ====================
    const sliderTrack = document.getElementById('productSliderTrack');
    const sliderPrev = document.getElementById('sliderPrev');
    const sliderNext = document.getElementById('sliderNext');

    if (sliderTrack && sliderPrev && sliderNext) {
        const scrollAmount = 340;

        sliderPrev.addEventListener('click', () => {
            sliderTrack.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
        });
        sliderNext.addEventListener('click', () => {
            sliderTrack.scrollBy({ left: scrollAmount, behavior: 'smooth' });
        });

        function updateArrows() {
            sliderPrev.disabled = sliderTrack.scrollLeft <= 10;
            sliderNext.disabled = sliderTrack.scrollLeft + sliderTrack.offsetWidth >= sliderTrack.scrollWidth - 10;
        }
        sliderTrack.addEventListener('scroll', updateArrows, { passive: true });
        updateArrows();
    }

    // ==================== PRODUCT GALLERY ====================
    const galleryMain = document.getElementById('galleryMain');
    if (galleryMain) {
        const mainImg = document.getElementById('galleryMainImg');
        const thumbs = document.querySelectorAll('.product-gallery__thumb');
        const prevBtn = document.getElementById('galleryPrev');
        const nextBtn = document.getElementById('galleryNext');
        const counter = document.getElementById('galleryCounter');
        let currentIdx = 0;
        const images = Array.from(thumbs).map(t => t.dataset.src);

        function switchImage(idx) {
            currentIdx = (idx + images.length) % images.length;
            mainImg.src = images[currentIdx];
            thumbs.forEach(t => t.classList.remove('active'));
            thumbs[currentIdx].classList.add('active');
            if (counter) counter.textContent = (currentIdx + 1) + ' / ' + images.length;
        }

        thumbs.forEach(thumb => {
            thumb.addEventListener('click', () => switchImage(parseInt(thumb.dataset.index)));
        });

        if (prevBtn) prevBtn.addEventListener('click', () => switchImage(currentIdx - 1));
        if (nextBtn) nextBtn.addEventListener('click', () => switchImage(currentIdx + 1));

        // Zoom
        mainImg.addEventListener('click', () => {
            mainImg.classList.toggle('zoomed');
        });
    }

    // ==================== PRODUCT TABS ====================
    const tabNav = document.getElementById('productTabsNav');
    if (tabNav) {
        tabNav.querySelectorAll('.product-tab-btn').forEach(btn => {
            btn.addEventListener('click', () => {
                tabNav.querySelectorAll('.product-tab-btn').forEach(b => b.classList.remove('active'));
                document.querySelectorAll('.product-tab-panel').forEach(p => p.classList.remove('active'));
                btn.classList.add('active');
                document.getElementById('tab-' + btn.dataset.tab).classList.add('active');
            });
        });
    }

    // ==================== QUANTITY SELECTOR ====================
    const qtyMinus = document.getElementById('qtyMinus');
    const qtyPlus = document.getElementById('qtyPlus');
    const qtyValue = document.getElementById('qtyValue');
    const qtyInput = document.getElementById('qtyInput');

    if (qtyMinus && qtyPlus) {
        qtyMinus.addEventListener('click', () => {
            let val = parseInt(qtyValue.textContent);
            if (val > 1) {
                val--;
                qtyValue.textContent = val;
                qtyInput.value = val;
            }
        });
        qtyPlus.addEventListener('click', () => {
            let val = parseInt(qtyValue.textContent);
            val++;
            qtyValue.textContent = val;
            qtyInput.value = val;
        });
    }

    // ==================== VARIANT OPTIONS ====================
    document.querySelectorAll('.color-option').forEach(btn => {
        btn.addEventListener('click', () => {
            const parent = btn.closest('.variant-select');
            parent.querySelectorAll('.color-option').forEach(b => b.classList.remove('active'));
            btn.classList.add('active');
        });
    });

    // ==================== COLLECTION SORT ====================
    const sortSelect = document.getElementById('sortSelect');
    if (sortSelect) {
        sortSelect.addEventListener('change', () => {
            const url = new URL(window.location.href);
            url.searchParams.set('sort_by', sortSelect.value);
            window.location.href = url.toString();
        });
    }

    // ==================== COOKIE CONSENT ====================
    const cookieBanner = document.getElementById('cookieBanner');
    const cookieAccept = document.getElementById('cookieAccept');

    if (cookieBanner && !localStorage.getItem('cookies_accepted')) {
        setTimeout(() => cookieBanner.classList.add('show'), 2000);
    }
    if (cookieAccept) {
        cookieAccept.addEventListener('click', () => {
            localStorage.setItem('cookies_accepted', 'true');
            cookieBanner.classList.remove('show');
        });
    }

    // ==================== SCROLL TO TOP ====================
    const scrollTopBtn = document.getElementById('scrollTop');
    if (scrollTopBtn) {
        window.addEventListener('scroll', () => {
            if (window.scrollY > 600) {
                scrollTopBtn.classList.add('visible');
            } else {
                scrollTopBtn.classList.remove('visible');
            }
        }, { passive: true });

        scrollTopBtn.addEventListener('click', () => {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        });
    }

    // ==================== STICKY HEADER SHADOW ====================
    const header = document.getElementById('siteHeader');
    if (header) {
        window.addEventListener('scroll', () => {
            if (window.scrollY > 10) {
                header.style.boxShadow = '0 4px 20px rgba(0,0,0,0.15)';
            } else {
                header.style.boxShadow = 'none';
            }
        }, { passive: true });
    }
});
